<h1 mat-dialog-title>{{ 'VoidAgreementTitle' | translate }}</h1>

<div mat-dialog-content [formGroup]="formGroup" fxLayout="column">
  <p>{{ 'VoidAgreementMessage' | translate }}</p>

  <mat-form-field appearance="outline" fxFlex="100">
    <mat-label>{{ 'AgreementVoidingReason' | translate }}</mat-label>
    <mat-select formControlName="AgreementVoidingReason">
      @for (reason of listOfAgreementVoidingReasons$ | async; track reason) {
        <mat-option #matOption [value]="reason.Id" (click)="onReasonChoice()">{{
          reason.Name
        }}</mat-option>
      }
    </mat-select>
    @if (AgreementVoidingReason.invalid && AgreementVoidingReason.touched) {
      <mat-error>
        {{ 'InvalidField' | translate }}
      </mat-error>
    }
  </mat-form-field>
</div>

<div mat-dialog-actions class="mat-dialog-actions">
  <button mat-button (click)="onDismiss()">{{ 'No' | translate }}</button>
  <button mat-raised-button color="primary" (click)="onConfirm()">{{ 'Yes' | translate }}</button>
</div>
